export const countWinRate = (item) =>
    item.config?.count_of_races ?
        item.config.count_of_win ?
            item.config.count_of_win / item.config.count_of_races * 100 : 0 : 0;